import { render } from "./DocumentTemplates.vue?vue&type=template&id=48e01925"
import script from "./DocumentTemplates.vue?vue&type=script&lang=js"
export * from "./DocumentTemplates.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__